import React from 'react';
import CursorClickIcon from '@heroicons/react/outline/CursorClickIcon.js';
import { BlockType } from '../../types/index.js';
import { In } from '../../utils/index.js';
import { AnnouncementBannerBlock as Component } from './Block.js';
import { AnnouncementBannerBlockSettings as Settings } from './Settings.js';
export const RegisteredAnnouncementBannerBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'AnnouncementBanner',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            availabilityConditions: {
                header: In([true, false]),
            },
            displayName: $t({
                id: 'Blocks.AnnouncementBanner.DisplayName',
                defaultMessage: 'Announcement Banner',
            }),
            Settings,
            Icon: React.createElement(CursorClickIcon, null),
            defaultProps: {
                title: $t({
                    id: 'Blocks.AnnouncementBanner.DefaultPropsTitle',
                    defaultMessage: 'A big announcement!',
                }),
                url: 'https://google.com',
                rounded: true,
                style: 'primary',
            },
        },
    };
};
//# sourceMappingURL=registered.js.map